import React, { useEffect, useState } from "react";
import {
  Accordion,
  Col,
  Form,
  Row,
  Spinner,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import VerBusinessDetails from "../../../components/common/VerBusinessDetails";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import { getBusinessDetails } from "../redux/action/getBusinessDetails";
import { useParams } from "react-router-dom";
import { getAppAction } from "../../opsUser/ppApplication/ppIndia/redux/action/getAppAction";
import Button from "../../../components/common/Button";
import IndiaBasicDetails from "./indiaBasicDetails";
import {
  createAuthBridgeCase,
  // getAuthBridgeToken,
  // initiateVKYC,
} from "../apis/getAuthBridgeToken";
import axios from "axios";
import { useForm } from "react-hook-form";
import {
  GuestAppAccessType,
  Vkyc,
} from "../../auth/redux/types/GuestLoginType";
import DatePicker from "../../../components/common/DatePicker";
import { getSessionId } from "../../../utils/tokenHandlers";
import { updateKeyPerson } from "../../opsUser/ppApplication/ppIndia/apis/updateKeyPerson";
import { KeyPersonDetailsType } from "../../opsUser/ppApplication/ppIndia/pages/types/KeyPersonDetailsType";
import DateTimePicker from "../../../components/common/dropdowns/DateTimePicker";
import { getVKYCToken } from "../apis/vkycToken";
import { createCaseInitialization } from "../apis/createCaseInitialization";
const VerIndividual: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  let { appId } = useParams();
  let customerId = Number(appId);
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<Vkyc>();
  useEffect(() => {
    // setValue("business_registered_with", "MCA");
    dispatch(getAppAction(customerId));
  }, [dispatch, customerId]);
  const state = useSelector(
    (state: RootState) => state.verification.verIndividualDetails
  );
  const businessState = useSelector(
    (state: RootState) => state.opsPpIndApp.getApp
  );
  const businessDetailsStore = businessState.data;
  const isCP = businessDetailsStore.is_counterparty;
  const [showToast, setShowToast] = useState(false);
  const [caseId, setCaseId] = useState<number>(0);
  const [vkycToken, setVkycToken] = useState("");
  const [showToastStatus, setShowToastStatus] = useState(false);
  const [statusMsg, SetStatusMsg] = useState("");
  const [showScheduleDate, setShowScheduleDate] = useState(false);
  // const [selectedDate, setSelectedDate] = useState<string>("");
  const [formattedDateTime, setFormattedDateTime] = useState("");

  const [vkycBtnSpinner, setVkycBtnSpinner] = useState(false);
  const [vkycScheduleSpinner, setVkycScheduleSpinner] = useState(false);
  if (!state.data || !state.data.data) {
    return <Row>Loading...</Row>;
  }

  const initiateVKYC = async ({
    email,
    state,
    fullName,
    phone,
  }: {
    email: string;
    state: string;
    fullName: string;
    phone: string;
  }) => {
    try {
      setShowScheduleDate(false);
      setVkycBtnSpinner(true);
      const result = await createAuthBridgeCase({
        fullName: fullName,
        email: email,
        phone: phone,
        state: state,
      });

      if (!result) {
        throw new Error("Failed to create VKYC case");
      }
      console.log(result);

      const { caseId, liveURL } = result;
      if (caseId && liveURL) {
        const keyPersonDetails = {
          key_person_vkyc_case_id: caseId,
          key_person_vkyc_live_case_url: liveURL,
        };

        const sessionID = getSessionId();

        updateKeyPerson(
          individualStore[0].id,
          keyPersonDetails as KeyPersonDetailsType,
          sessionID
        )
          .then((res) => {
            // console.log("Key person updated successfully", res.data);
            alert("Live VKYC email sent Successfully.");
            setVkycBtnSpinner(false);
          })
          .catch((err) => {
            // console.error("Failed to update key person", err);
            alert("Something went wrong!");
            setVkycBtnSpinner(false);
          });
      }
      setCaseId(caseId);
      setShowToast(true);
      // setVkycToken(token);
      setVkycBtnSpinner(false);
    } catch (error) {
      alert("❌ VKYC initiation failed");
      setVkycBtnSpinner(false);
    }
  };
  const handleDateChange = async ({
    email,
    state,
    fullName,
    phone,
    value,
  }: {
    email: string;
    state: string;
    fullName: string;
    phone: string;
    value: string;
  }) => {
    setVkycScheduleSpinner(true);

    try {
      const result = await createCaseInitialization({
        fullName,
        email,
        phone,
        state,
        value,
      });

      const { scheduled_time, created_at, status, case: caseNumber } = result;

      if (result) {
        const keyPersonDetails = {
          key_person_vkyc_scheduled_time: scheduled_time,
          key_person_vkyc_created_at: created_at,
          key_person_vkyc_status: status,
          key_person_vkyc_case_id: caseNumber,
        };

        const sessionID = getSessionId();

        await updateKeyPerson(
          individualStore[0].id,
          keyPersonDetails as KeyPersonDetailsType,
          sessionID
        );

        alert("✅ VKYC Scheduled Successfully. Please check email");
      }
    } catch (error: any) {
      console.error(
        "VKYC scheduling failed:",
        error.response?.data || error.message
      );

      alert("❌ VKYC scheduling failed. Please try again later.");
    } finally {
      setVkycScheduleSpinner(false);
    }
  };
  // const handleScheduleDate = async () => {
  //   const AUTHBRIDGE_BASE_URL = "https://uat-video.authbridge.com/api";
  //   try {
  //     const response = await axios.post(
  //       `${AUTHBRIDGE_BASE_URL}/case/sessions/`,
  //       {
  //         case: caseId, // number
  //         scheduled_time: "2025-11-23T11:49:00.006460+05:30", // string from DatePicker
  //       },
  //       {
  //         headers: {
  //           Authorization: `Token ${vkycToken}`, // ex: Token 4c973ef...
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     console.log("Session Scheduled:", response.data);
  //     // alert("Session scheduled successfully!");
  //     handleScheduleClick();
  //   } catch (error) {
  //     console.error("Error scheduling session:", error);
  //   }
  // };

  // const handleScheduleClick = async () => {
  //   const AUTHBRIDGE_BASE_URL = "https://uat-video.authbridge.com/api";

  //   try {
  //     if (!caseId || !vkycToken) {
  //       alert("❌ Missing VKYC token or case ID");
  //       return;
  //     }

  //     const response = await axios.patch(
  //       `${AUTHBRIDGE_BASE_URL}/case/cases/${caseId}/`,
  //       { status: "scheduled" },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Token ${vkycToken}`,
  //         },
  //       }
  //     );

  //     console.log("✅ VKYC Case Scheduled Successfully:", response.data);
  //     alert("VKYC Case Scheduled Successfully!");
  //   } catch (error: any) {
  //     console.error(
  //       "❌ Error scheduling VKYC case:",
  //       error.response?.data || error.message
  //     );
  //   }
  // };

  const handleStatusClick = async (caseID: number) => {
    setShowScheduleDate(false);

    try {
      const sessionId = getSessionId(); // get token

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}authbridge/case-status`,
        {
          jsonrpc: "2.0",
          method: "call",
          params: {
            case_id: caseID,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${sessionId}`,
          },
        }
      );

      SetStatusMsg(response.data?.result?.status || response.data?.status);
      setShowToastStatus(true);
    } catch (error: any) {
      console.error(
        "Error fetching status:",
        error.response?.data || error.message
      );
      alert("Something went wrong");
    }
  };
  const individualStore: Array<{
    id: number;
    customer_id: string;
    key_person_type_ids: {
      [x: string]: any;
      lov_display_value: string;
    };
    designation: string;
    if_others: string;
    partnership_percentage: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    related_person_type: string;
    father_spouse_name: string;
    mother_name: string;
    gender: string;
    date_of_birth: string;
    ownership_percentage: string;
    tax_id: string;
    employee_id: string;
    passport_number: string;
    passport_expiry_date: string;
    nationality_country_id: { name: string };
    tax_residency_country_id: { name: string };
    email: string;
    ckycno: string;
    is_politically_exposed: string;
    is_minor: boolean;
    is_beneficial_owner: string;
    is_admin: string;
    guardian_relation: string;
    guardian_name: string;
    key_person_address_line_1: string;
    key_person_address_line_2: string;
    key_person_address_city: string;
    key_person_address_district: string;
    key_person_address_state: string;
    key_person_address_pincode: string;
    key_person_address_country_id: { name: string };
    phone: string;
    phone_country_code: string;
    din: string;
    api_designation_flag: boolean;
    api_first_name_flag: boolean;
    api_last_name_flag: boolean;
    api_date_of_birth_flag: boolean;
    api_gender_flag: boolean;
    api_mother_name_flag: boolean;
    nationality_country_id_flag: boolean;
    api_tax_id_flag: boolean;
    api_din_flag: boolean;
    api_district_flag: boolean;
    api_state_flag: boolean;
    api_country_flag: boolean;
    api_city_flag: boolean;
    api_email_flag: boolean;
    api_if_others_flag: boolean;
    is_current_address: boolean;
    key_person_current_address_line_1: string;
    key_person_current_address_line_2: string;
    key_person_current_address_pincode: string;
    key_person_current_address_district: string;
    key_person_current_address_state: string;
    key_person_current_address_country_id: { name: string };
    key_person_current_address_city: string;
    key_person_vkyc_case_id: number;
    key_person_vkyc_live_case_url: string;
    key_person_vkyc_scheduled_time: string;
    key_person_vkyc_created_at: string;
    key_person_vkyc_status: string;
  }> = state.data.data.result.result;
  return (
    <>
      <ToastContainer position="middle-center" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={10000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto" style={{ color: "#214382" }}>
              VKYC Information
            </strong>
          </Toast.Header>
          <Toast.Body style={{ color: "#214382" }}>
            {/* {toastMessage} */}
            Video KYC Email Sent
          </Toast.Body>
        </Toast>
      </ToastContainer>

      <ToastContainer position="middle-center" className="p-3">
        <Toast
          onClose={() => setShowToastStatus(false)}
          show={showToastStatus}
          delay={10000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto" style={{ color: "#214382" }}>
              VKYC Status Information
            </strong>
          </Toast.Header>
          <Toast.Body style={{ color: "#214382" }}>
            {statusMsg}
            {/* Video KYC Email Sent */}
          </Toast.Body>
        </Toast>
      </ToastContainer>

      <Accordion>
        {individualStore.map((individual, index) => (
          <Accordion.Item key={index} eventKey={`I${index}`}>
            <Accordion.Header>
              {individual.first_name} {individual.last_name}
            </Accordion.Header>
            <Accordion.Body>
              {isCP ? (
                <>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Type"
                        defaultValue={individual.key_person_type_ids
                          .map(
                            (type: { lov_display_value: any }) =>
                              type.lov_display_value
                          )
                          .join(", ")}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Designation"
                        defaultValue={
                          individual.designation === "others"
                            ? individual.if_others
                            : individual.designation
                        }
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="First Name"
                        defaultValue={individual.first_name}
                        required
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Middle Name"
                        defaultValue={individual.middle_name}
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Last Name"
                        defaultValue={individual.last_name}
                        required
                      />
                    </Col>
                  </Row>
                  {/* <Row>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Mother Name"
                        defaultValue={individual.mother_name}
                      />
                    </Col>
                  </Row> */}
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Gender"
                        defaultValue={
                          individual.gender
                            ? individual.gender.charAt(0).toUpperCase() +
                              individual.gender.slice(1)
                            : ""
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Cellphone"
                        defaultValue={
                          individual.phone_country_code + -+individual.phone
                        }
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Email"
                        defaultValue={individual.email}
                      />
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Type"
                        defaultValue={individual.key_person_type_ids
                          .map(
                            (type: { lov_display_value: any }) =>
                              type.lov_display_value
                          )
                          .join(", ")}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Designation"
                        defaultValue={
                          individual.designation === "others"
                            ? individual.if_others
                            : individual.designation.charAt(0).toUpperCase() +
                              individual.designation.slice(1)
                        }
                        colored={individual.api_designation_flag}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="First Name"
                        defaultValue={individual.first_name}
                        colored={individual.api_first_name_flag}
                        required
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Middle Name"
                        defaultValue={individual.middle_name}
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Last Name"
                        defaultValue={individual.last_name}
                        colored={individual.api_last_name_flag}
                        required
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Mother Name"
                        defaultValue={individual.mother_name}
                        colored={individual.api_mother_name_flag}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Gender"
                        defaultValue={
                          individual.gender
                            ? individual.gender.charAt(0).toUpperCase() +
                              individual.gender.slice(1)
                            : ""
                        }
                        colored={individual.api_gender_flag}
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Date of Birth"
                        defaultValue={individual.date_of_birth}
                        colored={individual.api_date_of_birth_flag}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Is Politically Exposed"
                        defaultValue={
                          individual.is_politically_exposed ? "Yes" : "No"
                        }
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Is Minor"
                        defaultValue={
                          individual.is_minor === true ? "Yes" : "No"
                        }
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Nationality"
                        defaultValue={individual.nationality_country_id.name}
                        colored={individual.nationality_country_id_flag}
                        required
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="PAN/ TAX ID"
                        defaultValue={individual.tax_id}
                        colored={individual.api_tax_id_flag}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Passport No"
                        defaultValue={individual.passport_number}
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Passport Expiry"
                        defaultValue={individual.passport_expiry_date}
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Employee ID"
                        defaultValue={individual.employee_id}
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="DIN/ DPIN"
                        defaultValue={individual.din}
                        colored={individual.api_din_flag}
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="CKYC No"
                        defaultValue={individual.ckycno}
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Ownership %"
                        defaultValue={individual.ownership_percentage}
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Cellphone"
                        defaultValue={
                          individual.phone_country_code + -+individual.phone
                        }
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Guardian Name"
                        defaultValue={individual.guardian_name}
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Guardian Relation"
                        defaultValue={individual.guardian_relation}
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Address Line 1"
                        defaultValue={individual.key_person_address_line_1}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Address Line 2"
                        defaultValue={individual.key_person_address_line_2}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="City"
                        defaultValue={individual.key_person_address_city}
                        colored={individual.api_city_flag}
                        required
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="District"
                        defaultValue={individual.key_person_address_district}
                        colored={individual.api_district_flag}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="State/ County"
                        defaultValue={individual.key_person_address_state}
                        colored={individual.api_state_flag}
                        required
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Country"
                        defaultValue={
                          individual.key_person_address_country_id.name
                        }
                        colored={individual.api_country_flag}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Pincode"
                        defaultValue={individual.key_person_address_pincode}
                        required
                        // colored={individual.api_designation_flag}
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Tax Residency"
                        defaultValue={individual.tax_residency_country_id.name}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={12}>
                      <VerBusinessDetails
                        label="Email"
                        defaultValue={individual.email}
                        colored={individual.api_email_flag}
                        required
                      />
                    </Col>
                  </Row>
                  <Row md={12}>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Partnership %"
                        defaultValue={individual.partnership_percentage}
                      />
                    </Col>
                    <Col md={6}>
                      <VerBusinessDetails
                        label="Is Current Address"
                        defaultValue={
                          individual.key_person_current_address_line_1
                            ? "No"
                            : "Yes"
                        }
                      />
                    </Col>
                  </Row>
                  {individual.key_person_current_address_line_1 && (
                    <>
                      <Row md={12}>
                        <Col md={12}>
                          <VerBusinessDetails
                            label="Current Address Line 1"
                            defaultValue={
                              individual.key_person_current_address_line_1
                            }
                            required
                          />
                        </Col>
                      </Row>
                      <Row md={12}>
                        <Col md={12}>
                          <VerBusinessDetails
                            label="Current Address Line 2"
                            defaultValue={
                              individual.key_person_current_address_line_2
                            }
                            required
                          />
                        </Col>
                      </Row>
                      <Row md={12}>
                        <Col md={6}>
                          <VerBusinessDetails
                            label="Current City"
                            defaultValue={
                              individual.key_person_current_address_city
                            }
                            // colored={individual.api_city_flag}
                            required
                          />
                        </Col>
                        <Col md={6}>
                          <VerBusinessDetails
                            label="Current District"
                            defaultValue={
                              individual.key_person_current_address_district
                            }
                            // colored={individual.api_district_flag}
                            required
                          />
                        </Col>
                      </Row>
                      <Row md={12}>
                        <Col md={6}>
                          <VerBusinessDetails
                            label="Current State/ County"
                            defaultValue={
                              individual.key_person_current_address_state
                            }
                            // colored={individual.api_state_flag}
                            required
                          />
                        </Col>
                        <Col md={6}>
                          <VerBusinessDetails
                            label="Current Country"
                            defaultValue={
                              individual.key_person_current_address_country_id
                                .name
                            }
                            // colored={individual.api_country_flag}
                            required
                          />
                        </Col>
                      </Row>
                      <Row md={12}>
                        <Col md={6}>
                          <VerBusinessDetails
                            label="Current Pincode"
                            defaultValue={
                              individual.key_person_current_address_pincode
                            }
                            required
                            // colored={individual.api_designation_flag}
                          />
                        </Col>
                      </Row>
                    </>
                  )}
                </>
              )}
              {showScheduleDate && (
                <Form>
                  <Row md={12}>
                    <Col></Col>
                    <Col md={8}>
                      <DateTimePicker
                        name="vkyc_datetime"
                        label="VKYC Date & Time"
                        register={register}
                        required
                        // error={errors?.vkyc_datetime?.message}
                        onChange={(value) => {
                          // console.log("Formatted IST:", value);
                          setFormattedDateTime(value);
                          handleDateChange({
                            email: individual.email,
                            state: individual.key_person_address_state,
                            fullName: `${individual.first_name} ${individual.last_name}`,
                            phone: individual.phone,
                            value: value,
                          });
                        }}
                      />
                    </Col>
                    <Col></Col>
                  </Row>
                </Form>
              )}

              {/* <Row md={12}>
                <Col md={4}>
                  {vkycBtnSpinner ? (
                    <Spinner animation="border" variant="primary" />
                  ) : (
                    <Button
                      label="Initiate VKYC"
                      onClick={() =>
                        initiateVKYC({
                          email: individual.email,
                          state: individual.key_person_address_state,
                          fullName: `${individual.first_name} ${individual.last_name}`,
                          phone: individual.phone,
                        })
                      }
                    />
                  )}
                </Col>
                <Col md={4} className="text-center">
                  {vkycScheduleSpinner ? (
                    <Spinner animation="border" variant="primary" />
                  ) : (
                    <Button
                      label="Schedule"
                      onClick={() => {
                        // handleScheduleClick();
                        setShowScheduleDate(true);
                      }}
                    ></Button>
                  )}
                </Col>
                <Col md={4} className="text-end">
                  <Button
                    label="Check Status"
                    onClick={() => {
                      handleStatusClick(individual.key_person_vkyc_case_id);
                    }}
                  ></Button>
                </Col>
              </Row> */}
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  );
};
export default VerIndividual;
